{
  "HELP_CENTER": {
    "TITLE": "Centro de suporte",
    "NEW_PAGE": {
      "DESCRIPTION": "Create self-service help center portals for your customers. Help them find answers quickly, without waiting. Streamline inquiries, boost agent efficiency, and elevate customer support.",
      "CREATE_PORTAL_BUTTON": "Criar portal"
    },
    "HEADER": {
      "FILTER": "Filtrar por",
      "SORT": "Ordenar por",
      "LOCALE": "Linguagem",
      "SETTINGS_BUTTON": "Configurações",
      "NEW_BUTTON": "Novo artigo",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicado",
        "DRAFT": "Rascunho",
        "ARCHIVED": "Arquivado"
      },
      "TITLES": {
        "ALL_ARTICLES": "Todos os artigos",
        "MINE": "Meus artigos",
        "DRAFT": "Rascunhos de artigos",
        "ARCHIVED": "Artigos arquivados"
      },
      "LOCALE_SELECT": {
        "TITLE": "Selecionar linguagem",
        "PLACEHOLDER": "Selecionar linguagem",
        "NO_RESULT": "Nenhuma linguagem encontrada",
        "SEARCH_PLACEHOLDER": "Procurar linguagem"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Todos os artigos",
      "PUBLISH_BUTTON": "Publicar",
      "MOVE_TO_ARCHIVE_BUTTON": "Mover para arquivo",
      "PREVIEW": "Pré-visualizar",
      "ADD_TRANSLATION": "Adicionar tradução",
      "OPEN_SIDEBAR": "Abrir barra lateral",
      "CLOSE_SIDEBAR": "Fechar barra lateral",
      "SAVING": "A guardar...",
      "SAVED": "Guardado"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Carregar imagem",
        "UPLOADING": "A carregar...",
        "SUCCESS": "Imagem carregada com sucesso",
        "ERROR": "Erro ao carregar imagem",
        "UN_AUTHORIZED_ERROR": "You are not authorized to upload images",
        "ERROR_FILE_SIZE": "O tamanho da imagem deve ser inferior a {size}MB",
        "ERROR_FILE_FORMAT": "O formato da imagem deve ser jpg, jpeg ou png",
        "ERROR_FILE_DIMENSIONS": "As dimensões da imagem devem ser menores que 2000 x 2000"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Configurações de artigo",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categoria",
          "TITLE": "Selecionar categoria",
          "PLACEHOLDER": "Selecionar categoria",
          "NO_RESULT": "Nenhuma categoria encontrada",
          "SEARCH_PLACEHOLDER": "Pesquisar categoria"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Selecionar autor",
          "PLACEHOLDER": "Selecionar autor",
          "NO_RESULT": "Nenhum autor encontrado",
          "SEARCH_PLACEHOLDER": "Procurar autor"
        },
        "META_TITLE": {
          "LABEL": "Título meta",
          "PLACEHOLDER": "Adicionar título meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Descrição meta",
          "PLACEHOLDER": "Adicione a sua descrição meta para melhorar os resultados de SEO..."
        },
        "META_TAGS": {
          "LABEL": "Tags meta",
          "PLACEHOLDER": "Adicione tags meta separadas por vírgula..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arquivar artigo",
        "DELETE": "Apagar artigo"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Sem categoria",
      "SEARCH_RESULTS": "Procurar resultados para {query}",
      "EMPTY_TEXT": "Pesquisar artigos para inserir em respostas.",
      "SEARCH_LOADER": "A pesquisar...",
      "INSERT_ARTICLE": "Inserir",
      "NO_RESULT": "Nenhum artigo encontrado",
      "COPY_LINK": "Copiar link do artigo para a área de transferência",
      "OPEN_LINK": "Abrir artigo numa nova aba",
      "PREVIEW_LINK": "Pré-visualizar artigo"
    },
    "PORTAL": {
      "HEADER": "Portais",
      "DEFAULT": "Padrão",
      "NEW_BUTTON": "Novo portal",
      "ACTIVE_BADGE": "Ativa",
      "CHOOSE_LOCALE_LABEL": "Selecionar linguagem",
      "LOADING_MESSAGE": "A carregar portais...",
      "ARTICLES_LABEL": "Artigos",
      "NO_PORTALS_MESSAGE": "Não há portais disponíveis",
      "ADD_NEW_LOCALE": "Adicionar nova linguagem",
      "POPOVER": {
        "TITLE": "Portais",
        "PORTAL_SETTINGS": "Configurações do portal",
        "SUBTITLE": "Tem vários portais e pode ter diferentes linguagens para cada portal.",
        "CANCEL_BUTTON_LABEL": "Cancelar",
        "CHOOSE_LOCALE_BUTTON": "Selecionar linguagem"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "Artigos",
            "ADD": "Adicionar linguagem",
            "VISIT": "Abrir site",
            "SETTINGS": "Configurações",
            "DELETE": "Excluir"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configurações do portal",
            "ITEMS": {
              "NAME": "Nome",
              "DOMAIN": "Domínio personalizado",
              "SLUG": "Slug",
              "TITLE": "Título do portal",
              "THEME": "Cor do tema",
              "SUB_TEXT": "Sub texto do portal"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Linguagens disponíveis",
            "TABLE": {
              "NAME": "Nome do local",
              "CODE": "Código do local",
              "ARTICLE_COUNT": "Número de artigos",
              "CATEGORIES": "Número de categorias",
              "SWAP": "Trocar",
              "DELETE": "Excluir",
              "DEFAULT_LOCALE": "Padrão"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Apagar portal",
          "MESSAGE": "Tem a certeza que pretende apagar este portal",
          "YES": "Sim, apagar portal",
          "NO": "Não, manter portal",
          "API": {
            "DELETE_SUCCESS": "Portal apagado com sucesso",
            "DELETE_ERROR": "Erro ao apagar portal"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "CNAME instructions sent successfully",
            "ERROR_MESSAGE": "Error while sending CNAME instructions"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Editar portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informação básica"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalização do portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorias"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Locais"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorias em",
          "NEW_CATEGORY": "Nova categoria",
          "TABLE": {
            "NAME": "Nome",
            "DESCRIPTION": "Descrição",
            "LOCALE": "Local",
            "ARTICLE_COUNT": "Número de artigos",
            "ACTION_BUTTON": {
              "EDIT": "Editar categoria",
              "DELETE": "Apagar categoria"
            },
            "EMPTY_TEXT": "Nenhuma categoria encontrada"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Atualizar configurações básicas"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informações do centro de ajuda",
            "BODY": "Informações básicas sobre o portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalização do centro de ajuda",
            "BODY": "Personalizar portal"
          },
          "FINISH": {
            "TITLE": "Pronto! 🎉",
            "BODY": "Está tudo pronto!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Voltar",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Criar portal",
            "TITLE": "Informações do centro de ajuda",
            "CREATE_BASIC_SETTING_BUTTON": "Criar configurações básicas do portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalização do portal",
            "TITLE": "Personalização do centro de ajuda",
            "UPDATE_PORTAL_BUTTON": "Atualizar definições do portal"
          },
          "FINISH_PAGE": {
            "TITLE": "Está tudo pronto! 🎉",
            "MESSAGE": "Agora já pode ver o portal criado na sua página de todos os portais.",
            "FINISH": "Ir para a página de todos os portais"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Carregar logo",
          "HELP_TEXT": "Este logo será exibido no cabeçalho do portal.",
          "IMAGE_UPLOAD_SUCCESS": "Logo carregado com sucesso",
          "IMAGE_UPLOAD_ERROR": "Logo apagado com sucesso",
          "IMAGE_DELETE_ERROR": "Erro ao apagar logo"
        },
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome do portal",
          "HELP_TEXT": "O nome será usado internamente no portal público.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug do portal para URLs",
          "ERROR": "Slug é obrigatório"
        },
        "DOMAIN": {
          "LABEL": "Domínio personalizado",
          "PLACEHOLDER": "Domínio personalizado do portal",
          "HELP_TEXT": "Add only If you want to use a custom domain for your portals. Eg: {exampleURL}",
          "ERROR": "Insira um URL de domínio válido"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link da Página Inicial",
          "PLACEHOLDER": "Link da página inicial do portal",
          "HELP_TEXT": "The link used to return from the portal to the home page. Eg: {exampleURL}",
          "ERROR": "Insira um URL de página inicial válido"
        },
        "THEME_COLOR": {
          "LABEL": "Cor do tema do portal",
          "HELP_TEXT": "Esta cor será mostrada como a cor do tema do portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Título da página",
          "PLACEHOLDER": "Título da página do portal",
          "HELP_TEXT": "O título da página será usado no portal público.",
          "ERROR": "Título da página obrigatório"
        },
        "HEADER_TEXT": {
          "LABEL": "Texto do cabeçalho",
          "PLACEHOLDER": "Texto do cabeçalho do portal",
          "HELP_TEXT": "O texto do cabeçalho do portal será usado no portal visível ao público.",
          "ERROR": "Texto do cabeçalho do portal obrigatório"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal criado com sucesso.",
          "ERROR_MESSAGE_FOR_BASIC": "Não foi possível criar o portal. Por favor, tente novamente.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal atualizado com sucesso.",
          "ERROR_MESSAGE_FOR_UPDATE": "Não foi possível atualizar o portal. Por favor, tente novamente."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Adicionar um novo local",
        "SUB_TITLE": "Isto adiciona um novo local à sua lista de traduções disponíveis.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Local",
          "PLACEHOLDER": "Selecione um local",
          "ERROR": "Local obrigatório"
        },
        "BUTTONS": {
          "CREATE": "Criar local",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Local adicionado com sucesso",
          "ERROR_MESSAGE": "Não foi possível adicionar o local. Por favor, tente novamente."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Local padrão atualizado com sucesso",
          "ERROR_MESSAGE": "Não foi possível atualizar o local padrão. Por favor, tente novamente."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Local removido do portal com sucesso",
          "ERROR_MESSAGE": "Não foi possível remover o local do portal. Por favor, tente novamente."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "A carregar artigos...",
      "404": "Nenhum artigo corresponde à sua pesquisa 🔍",
      "NO_ARTICLES": "Não há artigos disponíveis",
      "HEADERS": {
        "TITLE": "Título",
        "CATEGORY": "Categoria",
        "READ_COUNT": "Visualizações",
        "STATUS": "Estado",
        "LAST_EDITED": "Última edição"
      },
      "COLUMNS": {
        "BY": "por",
        "AUTHOR_NOT_AVAILABLE": "Autor não disponível"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "A carregar artigo...",
      "TITLE_PLACEHOLDER": "Título do artigo aqui",
      "CONTENT_PLACEHOLDER": "Escreva o seu artigo aqui",
      "API": {
        "ERROR": "Erro ao guardar artigo"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Erro ao publicar artigo",
        "SUCCESS": "Artigo publicado com sucesso"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Erro ao arquivar artigo",
        "SUCCESS": "Artigo arquivado com sucesso"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Error while drafting article",
        "SUCCESS": "Article drafted successfully"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirmar exclusão",
          "MESSAGE": "Tem a certeza que pretende excluir o artigo?",
          "YES": "Sim, excluir",
          "NO": "Não, manter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artigo excluído com sucesso",
        "ERROR_MESSAGE": "Erro ao excluir artigo"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder articles. Please try again."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder categories. Please try again."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Adicione o título do artigo e o conteúdo em seguida, posteriomente as configurações apenas serão editáveis por si"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Pesquisar artigos"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Criar categoria",
        "SUB_TITLE": "A categoria será usada no portal público para categorizar artigos.",
        "PORTAL": "Portal",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome da categoria",
          "HELP_TEXT": "O ícone e o nome da categoria serão usados no portal público para categorizar artigos.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categoria slug para URLs",
          "HELP_TEXT": "app.chatwoot.com/hc/meu-portal/en-US/categorias/meu-slug",
          "ERROR": "Slug obrigatória"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Breve descrição da categoria.",
          "ERROR": "Descrição obrigatória"
        },
        "BUTTONS": {
          "CREATE": "Criar categoria",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria criada com sucesso",
          "ERROR_MESSAGE": "Não é possível criar a categoria"
        }
      },
      "EDIT": {
        "TITLE": "Editar uma categoria",
        "SUB_TITLE": "Editar uma categoria atualizará a categoria no portal público.",
        "PORTAL": "Portal",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome da categoria",
          "HELP_TEXT": "O ícone e o nome da categoria serão usados no portal público para categorizar artigos.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categoria slug para URLs",
          "HELP_TEXT": "app.chatwoot.com/hc/meu-portal/en-US/categorias/meu-slug",
          "ERROR": "Slug é obrigatório"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Breve descrição da categoria.",
          "ERROR": "Descrição é obrigatória"
        },
        "BUTTONS": {
          "CREATE": "Atualizar categoria",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria atualizada com sucesso",
          "ERROR_MESSAGE": "Não foi possível atualizar a categoria"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoria apagada com sucesso",
          "ERROR_MESSAGE": "Não é possível apagar a categoria"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Pesquisar artigos",
      "PLACEHOLDER": "Pesquisar artigos",
      "NO_RESULT": "Nenhum artigo encontrado",
      "SEARCHING": "A pesquisar...",
      "SEARCH_BUTTON": "Procurar",
      "INSERT_ARTICLE": "Inserir link",
      "IFRAME_ERROR": "O URL está vazio ou é inválido. Não é possível exibir o conteúdo.",
      "OPEN_ARTICLE_SEARCH": "Inserir artigo do centro de ajuda",
      "SUCCESS_ARTICLE_INSERTED": "Artigo inserido com sucesso",
      "PREVIEW_LINK": "Pré-visualizar artigo",
      "CANCEL": "Fechar",
      "BACK": "Voltar",
      "BACK_RESULTS": "Voltar aos resultados"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centro de suporte",
      "DESCRIPTION": "Crie portais self-service de fácil utilização. Ajude os seus utilizadores a aceder aos artigos e obter suporte 24/7. Atualize a sua subscrição para habilitar este recurso.",
      "SELF_HOSTED_DESCRIPTION": "Crie portais self-service de fácil utilização. Ajude os seus utilizadores a aceder aos artigos e obter suporte 24/7. Entre em contacto com o administrador para ativar este recurso.",
      "BUTTON": {
        "LEARN_MORE": "Saiba mais",
        "UPGRADE": "Atualizar"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Múltiplos portais",
          "DESCRIPTION": "Crie vários portais de ajuda centralizada para diferentes produtos usando a mesma conta."
        },
        "LOCALES": {
          "TITLE": "Suporte total para linguagens",
          "DESCRIPTION": "Localize o portal na sua linguagem. Suportamos todas as linguagens e permitimos traduções para todos os artigos."
        },
        "SEO": {
          "TITLE": "Design SEO-friendly",
          "DESCRIPTION": "Personalize as suas meta tags para melhorar a visibilidade nos motores de busca com as nossas páginas SEO-friendly."
        },
        "API": {
          "TITLE": "Suporte completo da API",
          "DESCRIPTION": "Use o portal como um CMS com frameworks de front-end externos usando as nossas APIs."
        }
      }
    },
    "LOADING": "A carregar...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} view | {count} views",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publicar",
            "DRAFT": "Rascunho",
            "ARCHIVE": "Archive",
            "TRANSLATE": "Traduzir",
            "DELETE": "Excluir"
          },
          "STATUS": {
            "DRAFT": "Rascunho",
            "PUBLISHED": "Publicado",
            "ARCHIVED": "Arquivado"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "Uncategorised"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "All articles",
          "MINE": "Minhas",
          "DRAFT": "Rascunho",
          "PUBLISHED": "Publicado",
          "ARCHIVED": "Arquivado"
        },
        "CATEGORY": {
          "ALL": "All categories"
        },
        "LOCALE": {
          "ALL": "All locales"
        },
        "SEARCH_PLACEHOLDER": "Pesquisar artigos...",
        "NEW_ARTICLE": "New article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Write an article",
          "SUBTITLE": "Write a rich article, let’s get started!",
          "BUTTON_LABEL": "New article"
        },
        "MINE": {
          "TITLE": "You haven't written any articles here",
          "SUBTITLE": "All articles written by you show up here for quick access."
        },
        "DRAFT": {
          "TITLE": "There are no articles in drafts",
          "SUBTITLE": "Draft articles will appear here"
        },
        "PUBLISHED": {
          "TITLE": "There are no published articles",
          "SUBTITLE": "Published articles will appear here"
        },
        "ARCHIVED": {
          "TITLE": "There are no articles in the archive",
          "SUBTITLE": "Archived articles don't show up on the portal, you can use it to mark deprecated or outdated pages"
        },
        "CATEGORY": {
          "TITLE": "There are no articles in this category",
          "SUBTITLE": "Articles in this category will appear here"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "Traduzir",
        "SELECT_ALL": "Selecionar todas ({count})",
        "SELECTED_COUNT": "{count} selected",
        "CLEAR_SELECTION": "Clear selection",
        "TRANSLATE_BUTTON": "Traduzir",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Publicar",
        "DRAFT": "Rascunho",
        "ARCHIVE": "Archive",
        "TRANSLATE": "Traduzir",
        "MOVE_TO_CATEGORY": "Categoria",
        "DELETE": "Excluir",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "Excluir",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova categoria",
        "EDIT_CATEGORY": "Editar categoria",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n} category | {n} categories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nenhuma categoria encontrada",
        "SUBTITLE": "Categories will appear here. You can add a category by clicking the 'New Category' button."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria criada com sucesso",
            "ERROR_MESSAGE": "Não é possível criar a categoria"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria atualizada com sucesso",
            "ERROR_MESSAGE": "Não foi possível atualizar a categoria"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria apagada com sucesso",
            "ERROR_MESSAGE": "Não é possível apagar a categoria"
          }
        },
        "HEADER": {
          "CREATE": "Criar categoria",
          "EDIT": "Editar categoria",
          "DESCRIPTION": "Editar uma categoria atualizará a categoria no portal público.",
          "PORTAL": "Portal",
          "LOCALE": "Local"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nome:",
            "PLACEHOLDER": "Nome da categoria",
            "ERROR": "Nome é obrigatório"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Categoria slug para URLs",
            "ERROR": "Slug obrigatória",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descrição",
            "PLACEHOLDER": "Breve descrição da categoria.",
            "ERROR": "Descrição é obrigatória"
          }
        },
        "BUTTONS": {
          "CREATE": "Criar",
          "EDIT": "Atualização",
          "CANCEL": "Cancelar"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No locales available | {n} locale | {n} locales",
      "NEW_LOCALE_BUTTON_TEXT": "New locale",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} category | {count} categories",
        "DEFAULT": "Padrão",
        "DRAFT": "Rascunho",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Make default",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "Excluir"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "Search...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "Sem categoria"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "Nome:"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Adicionar nova linguagem",
        "DESCRIPTION": "Select the language in which this article will be written. This will be added to your list of translations, and you can add more later.",
        "COMBOBOX": {
          "PLACEHOLDER": "Selecionar linguagem..."
        },
        "STATUS": {
          "LABEL": "Situação",
          "OPTIONS": {
            "LIVE": "Publicado",
            "DRAFT": "Rascunho"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Local adicionado com sucesso",
          "ERROR_MESSAGE": "Não foi possível adicionar o local. Por favor, tente novamente."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "A guardar...",
          "SAVED": "Guardado"
        },
        "PREVIEW": "Pré-visualizar",
        "PUBLISH": "Publicar",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "Rascunho",
        "ARCHIVE": "Archive",
        "BACK_TO_ARTICLES": "Back to articles"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "Título"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "More properties",
        "UNCATEGORIZED": "Sem categoria",
        "EDITOR_PLACEHOLDER": "Write something..."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Article properties",
        "META_DESCRIPTION": "Descrição meta",
        "META_DESCRIPTION_PLACEHOLDER": "Add meta description",
        "META_TITLE": "Título meta",
        "META_TITLE_PLACEHOLDER": "Add meta title",
        "META_TAGS": "Tags meta",
        "META_TAGS_PLACEHOLDER": "Add meta tags"
      },
      "API": {
        "ERROR": "Erro ao guardar artigo"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "New portal",
      "PORTALS": "Portais",
      "CREATE_PORTAL": "Create and manage multiple portals",
      "ARTICLES": "Artigos",
      "DOMAIN": "domínio",
      "PORTAL_NAME": "Nome do portal"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Create new portal",
      "DESCRIPTION": "Give your portal a name and create a user-friendly URL slug. You can modify both later in the settings.",
      "CONFIRM_BUTTON_LABEL": "Criar",
      "NAME": {
        "LABEL": "Nome:",
        "PLACEHOLDER": "User Guide | Chatwoot",
        "MESSAGE": "Choose an name for your portal.",
        "ERROR": "Nome é obrigatório"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug obrigatória",
        "FORMAT_ERROR": "Por favor, introduza um slug válido, por exemplo: guia-do-utilizador"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Não foi possível carregar a imagem! Tente novamente",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the logo",
          "IMAGE_DELETE_SUCCESS": "Logo apagado com sucesso",
          "IMAGE_DELETE_ERROR": "Unable to delete logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "O tamanho da imagem deve ser inferior a {size}MB"
        },
        "NAME": {
          "LABEL": "Nome:",
          "PLACEHOLDER": "Nome do portal",
          "ERROR": "Nome é obrigatório"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text",
          "PLACEHOLDER": "Texto do cabeçalho do portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title",
          "PLACEHOLDER": "Título da página do portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home page link",
          "PLACEHOLDER": "Link da página inicial do portal",
          "ERROR": "Enter a valid URL. The Home page link must start with 'http://' or 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat widget",
          "PLACEHOLDER": "Select live chat widget",
          "HELP_TEXT": "Select a live chat widget that will appear on your help center",
          "NONE_OPTION": "No widget"
        },
        "BRAND_COLOR": {
          "LABEL": "Brand color"
        },
        "SAVE_CHANGES": "Save changes"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domínio personalizado",
          "LABEL": "Domínio personalizado:",
          "DESCRIPTION": "You can host your portal on a custom domain. For instance, if your website is yourdomain.com and you want your portal available at docs.yourdomain.com, simply enter that in this field.",
          "STATUS_DESCRIPTION": "Your custom portal will start working as soon as it is verified.",
          "PLACEHOLDER": "Domínio personalizado do portal",
          "EDIT_BUTTON": "Editar",
          "ADD_BUTTON": "Add custom domain",
          "STATUS": {
            "LIVE": "Disponível",
            "PENDING": "Awaiting verification",
            "ERROR": "Verification failed"
          },
          "DIALOG": {
            "ADD_HEADER": "Add custom domain",
            "EDIT_HEADER": "Edit custom domain",
            "ADD_CONFIRM_BUTTON_LABEL": "Add domain",
            "EDIT_CONFIRM_BUTTON_LABEL": "Update domain",
            "LABEL": "Domínio personalizado",
            "PLACEHOLDER": "Domínio personalizado do portal",
            "ERROR": "Custom domain is required",
            "FORMAT_ERROR": "Please enter a valid domain URL e.g. docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS configuration",
            "DESCRIPTION": "Log in to the account you have with your DNS provider, and add a CNAME record for subdomain pointing to chatwoot.help",
            "COPY": "Successfully copied CNAME",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Send instructions",
              "DESCRIPTION": "If you would prefer to have someone from your development team to handle this step, you can enter email address below, and we will send them the required instructions.",
              "PLACEHOLDER": "Enter their email",
              "ERROR": "Enter a valid email address",
              "SEND_BUTTON": "Enviar"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Delete {portalName}",
          "HEADER": "Apagar portal",
          "DESCRIPTION": "Permanently delete this portal. This action is irreversible",
          "DIALOG": {
            "HEADER": "Sure you want to delete {portalName}?",
            "DESCRIPTION": "This is a permanent action that cannot be reversed.",
            "CONFIRM_BUTTON_LABEL": "Excluir"
          }
        },
        "EDIT_CONFIGURATION": "Edit configuration"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Aparência",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "Excluir"
        },
        "SAVE": "Save changes"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal criado com sucesso",
          "ERROR_MESSAGE": "Unable to create portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal atualizado com sucesso",
          "ERROR_MESSAGE": "Unable to update portal"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Upload PDF Document",
      "DESCRIPTION": "Upload a PDF document to automatically generate FAQs using AI",
      "DRAG_DROP_TEXT": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "ADDITIONAL_CONTEXT_LABEL": "Additional Context (Optional)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Provide any additional context or instructions for FAQ generation...",
      "UPLOADING": "A carregar...",
      "UPLOAD": "Upload & Process",
      "CANCEL": "Cancelar",
      "ERROR_INVALID_TYPE": "Please select a valid PDF file",
      "ERROR_FILE_TOO_LARGE": "File size must be less than 512MB",
      "ERROR_UPLOAD_FAILED": "Failed to upload PDF. Please try again."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF Documents",
      "DESCRIPTION": "Manage uploaded PDF documents and generate FAQs from them",
      "UPLOAD_PDF": "Upload PDF",
      "UPLOAD_FIRST_PDF": "Upload your first PDF",
      "UPLOADED_BY": "Uploaded by",
      "GENERATE_FAQS": "Generate FAQs",
      "GENERATING": "A gerar...",
      "CONFIRM_DELETE": "Tem a certeza que pretende apagar o {filename}?",
      "EMPTY_STATE": {
        "TITLE": "No PDF documents yet",
        "DESCRIPTION": "Upload PDF documents to automatically generate FAQs using AI"
      },
      "STATUS": {
        "UPLOADED": "Ready",
        "PROCESSING": "Processing",
        "PROCESSED": "Concluída",
        "FAILED": "Failed"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Content Generation",
      "DESCRIPTION": "Upload PDF documents to automatically generate FAQ content using AI",
      "UPLOAD_TITLE": "Upload PDF Document",
      "DRAG_DROP": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "UPLOADING": "Processing document...",
      "UPLOAD_SUCCESS": "Document processed successfully!",
      "UPLOAD_ERROR": "Failed to upload document. Please try again.",
      "INVALID_FILE_TYPE": "Please select a valid PDF file",
      "FILE_TOO_LARGE": "File size must be less than 512MB",
      "GENERATED_CONTENT": "Generated FAQ Content",
      "PUBLISH_SELECTED": "Publish Selected",
      "PUBLISHING": "Publishing...",
      "FROM_DOCUMENT": "From document",
      "NO_CONTENT": "No generated content available. Upload a PDF document to get started.",
      "LOADING": "Loading generated content..."
    }
  }
}
